tinymce.PluginManager.add('insertTel', function (editor, url) {
    var openDialog = function () {
        return editor.windowManager.open({
            title: '插入电话',
            body: {
                type: 'panel',
                items: [
                    {
                        type: 'input',
                        name: 'title',
                        label: ''
                    }
                ]
            },
            buttons: [
                {
                    type: 'cancel',
                    text: 'Close'
                },
                {
                    type: 'submit',
                    text: 'Save',
                    primary: true
                }
            ],
            onSubmit: function (api) {
                var data = api.getData();
                // 将输入框内容插入到内容区光标位置
                editor.insertContent('<a href="tel:' + data.title + '">' + data.title + '</a>');
                api.close();
            }
        });
    };

    editor.ui.registry.addIcon(
        "tel-icon",
        `<svg width="20" height="20" t="1730703030893" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5252" width="200" height="200"><path d="M969.154011 895.670857 912.504869 954.112C869.423726 998.509714 809.483154 1023.963429 748.006583 1023.963429 721.748297 1023.963429 695.819154 1019.428571 671.023726 1010.505143 364.116297 899.876571 120.98944 645.668571 20.674011 330.459429-9.460846 235.739429 22.502583 131.510857 100.216869 71.168L149.734583 32.694857C177.236297 11.300571 210.150583-0.036571 244.89344-0.036571 303.992869-0.036571 357.53344 33.28 384.596297 86.893714L468.344869 252.672C476.280869 268.434286 480.486583 286.061714 480.486583 303.725714 480.486583 331.812571 470.210011 358.656 451.558583 379.392L434.114011 398.701714C416.779154 417.901714 413.012297 446.317714 424.751726 469.467429 453.350583 525.933714 497.784869 571.172571 553.263726 600.283429 575.608869 612.059429 604.354011 608.073143 622.786011 590.774857L641.803154 573.074286C674.827154 542.098286 726.356297 534.966857 766.255726 555.885714L929.071726 641.097143C981.771154 668.708571 1014.539154 723.2 1014.539154 783.396571 1014.539154 825.636571 998.447726 865.536 969.154011 895.670857ZM941.396297 768C941.396297 715.373714 721.967726 621.714286 721.967726 621.714286 691.174583 610.450286 648.824869 658.285714 648.824869 658.285714 572.536869 714.788571 518.81344 671.926857 502.539154 658.285714 454.923154 618.459429 390.191726 532.370286 356.25344 475.428571 330.872869 432.749714 341.734583 382.171429 356.25344 365.714286 356.25344 365.714286 405.40544 323.291429 392.824869 292.571429 354.46144 197.376 294.594011 56.393143 246.539154 73.142857 204.847726 86.893714 30.255726 144.786286 109.21344 356.388571 249.282011 731.465143 540.792869 882.468571 718.23744 950.820571 841.958583 959.926857 951.234011 803.730286 941.396297 768Z" fill="#333333" p-id="5253"></path></svg>`
    );

    // 注册一个工具栏按钮名称
    editor.ui.registry.addButton('insertTel', {
        icon: `tel-icon`,
        tooltip: '插入电话',
        onAction: function () {
            window.postMessage("openInsertTel", "*");
            //openDialog();
        }
    });

    // 注册一个菜单项名称 menu/menubar
    editor.ui.registry.addMenuItem('insertTel', {
        text: '插入电话',
        onAction: function () {
            openDialog();
        }
    });

    return {
        getMetadata: function () {
            return {
                //插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
                name: "",//插件名称
                url: "", //作者网址
            };
        }
    };
});